
export default {
  name: 'TrulyEmpty',
};
